module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePageWeb_EN_Euro.e17c4bcc.webp";